import React, { useState } from 'react';
import { checkSurcharge } from '../../actions/api';

interface InputProviderProp {
  children: React.ReactNode
}

export const InvoiceContext = React.createContext({
  invoicingData: { },
  setInvoiceData: (invoice: any) => invoice,
  surcharge: {
    responseMessage: '',
    isSurcharge: false,
  },
  getSurchargeStatus: (cardNumber) => cardNumber,
  isAch: false,
  setACHFlag: () => {},
});

export function InvoiceContectElement({ children }: InputProviderProp) {
  const [invoicingData, setInvoicingData] = useState({ });
  const [surcharge, setSurcharge] = useState({
    responseMessage: '',
    isSurcharge: false,
  });

  const [isAch, setIsAch] = useState(false);

  function setInvoiceData(invoice: any) {
    setInvoicingData(invoice);
  }
  async function getSurchargeStatus(cardNumber) {
    const productTransactionId = invoicingData.cc_product_transaction.id;
    const response = await checkSurcharge(productTransactionId, cardNumber);
    setSurcharge(response.data);
  }

  function setACHFlag(val) {
    setIsAch(val);
  }
  return (
    <>
      {/* eslint-disable-next-line max-len */}
      <InvoiceContext.Provider value={
         {
           invoicingData, setInvoiceData, surcharge, getSurchargeStatus, isAch, setACHFlag,
         }
       }
      >
        {children}
      </InvoiceContext.Provider>
      {/* eslint-disable-next-line max-len */}
    </>
  );
}
